import React from 'react'
import classnames from 'classnames'
import * as styles from './index.module.less'
interface ListProps {
  className?: string
  childClassName?: string
  direction?: boolean
  data?: {
    icon_path?: string
    text: string
  }[]
}

const List: React.FC<ListProps> = ({ className, childClassName, data, direction = false }) => {
  return (
    <ul className={classnames(styles.menu, className)}>
      {data?.map((item, index) => {
        return (
          <li
            className={classnames(
              'list-child ',
              { 'pl-[20px] pr-[20px]': item?.icon_path, 'text-right': direction },
              childClassName,
            )}
            key={index}
          >
            <span>{item?.text}</span>
            {item?.icon_path && (
              <span
                style={{
                  left: !direction ? 0 : 'auto',
                  right: direction ? 0 : 'auto',
                  background: item?.icon_path
                    ? `url(${item?.icon_path}) no-repeat`
                    : 'url(https://ow-file.sensorsdata.cn/www/solutions/cusotmeriourney/check_icon.png) no-repeat',
                  backgroundSize: '100% 100%',
                }}
                className="list-icon"
              />
            )}
          </li>
        )
      })}
    </ul>
  )
}

export default List
